import type { StyleObject } from 'styletron-react'

// The Settings sub-tab <h3>, measured off prototype v70's own computed styles
// (`.sp-title`): 24px / 700 / 28px line-height / 0.25px letter-spacing. Font
// size and weight already come from the app's global `h3` rule; the two values
// here are the ones that rule gets wrong. Its letter-spacing is derived from a
// shared em formula that resolves to 0.75px at 24px, and it sets no
// line-height at all, so the heading falls to the browser default (~28.8px for
// Lato).
//
// Shared by every Settings sub-tab title rather than repeated per pane: the
// design draws all four the same, so they move together or not at all.
export const PANE_TITLE_STYLE: StyleObject = {
  lineHeight: '28px',
  letterSpacing: '0.25px',
}
